import { Component, Input } from '@angular/core';

import { ApContentService } from '@ap/content';

import { ChatNotification } from '../mijn-overzicht-template/conversational/conversational.model';
import content from '../mijn-template.content.json';

import {
    ActieTemplateSettings,
    MijnOmgevingTemplates,
    OverzichtTemplateSettings,
    TemplateClickEvent,
    TemplateSettings
} from './mijn-omgeving-template.model';
import { MijnOmgevingTemplateService } from './mijn-omgeving-template.service';

@Component({
    selector: 'mijn-omgeving-template',
    styleUrls: ['./mijn-omgeving-template.component.scss'],
    templateUrl: './mijn-omgeving-template.component.html',
    standalone: false
})
export class MijnOmgevingTemplateComponent {
    @Input()
    public currentTemplate: MijnOmgevingTemplates;

    @Input()
    public templateSettings: TemplateSettings;

    constructor(
        private readonly contentService: ApContentService,
        private readonly mijnOmgevingTemplateService: MijnOmgevingTemplateService
    ) {
        this.contentService.addContentItems(content);
    }

    public get overzichtTemplateSettings(): OverzichtTemplateSettings {
        return this.templateSettings as OverzichtTemplateSettings;
    }

    public get actieTemplateSettings(): ActieTemplateSettings {
        return this.templateSettings as ActieTemplateSettings;
    }

    public primaryActionClicked(): void {
        this.mijnOmgevingTemplateService.sendTemplateClickEvent(
            (this.templateSettings as OverzichtTemplateSettings).webcomponentIdentifier,
            TemplateClickEvent.PRIMARYACTION
        );
    }
    public secondaryActionClicked(): void {
        this.mijnOmgevingTemplateService.sendTemplateClickEvent(
            (this.templateSettings as OverzichtTemplateSettings).webcomponentIdentifier,
            TemplateClickEvent.SECONDARYACTION
        );
    }

    public chatNotificationSent(event: ChatNotification): void {
        this.mijnOmgevingTemplateService.sendTemplateClickEvent(
            (this.templateSettings as OverzichtTemplateSettings).webcomponentIdentifier,
            TemplateClickEvent.CHATNOTIFICATION,
            event
        );
    }

    public closeTemplate(): void {
        this.mijnOmgevingTemplateService.sendTemplateClickEvent(
            (this.templateSettings as ActieTemplateSettings).webcomponentIdentifier,
            TemplateClickEvent.CLOSETEMPLATE
        );
    }

    public formatTabTitle(tabTitle: string): string {
        if (!!tabTitle) {
            return `${tabTitle} - ${this.contentService.get('mijn.omgeving.template.tabTitle.postFix')}`;
        }
        return tabTitle;
    }
}
